import type { FamilyLinks } from "../../../model/family-links.ts";
import { PRICING_WORDS_EN as EN } from "./pricing-words-en.ts";
import { PRICING_WORDS_ES as ES } from "./pricing-words-es.ts";

// The pricing family's pages, for the footer and other pages' bodies: one entry per page, its
// label from the two words files.
export const PRICING_LINKS: FamilyLinks = {
  title: { en: EN.footerTitle, es: ES.footerTitle },
  links: [{ label: { en: EN.footerLink, es: ES.footerLink }, href: "/pricing" }],
};
